import {
  Card,
  CardBody,
  Typography,
  Button,
} from "@material-tailwind/react";
import {
  GlobeAmericasIcon,
  DocumentCheckIcon,
  CloudArrowDownIcon,
  VideoCameraIcon,
  BookOpenIcon,
  ClipboardDocumentIcon,
} from "@heroicons/react/24/solid";

export function ItemCard({ item }) {
  const IconHeader = (category) => {
    const baseClass = "h-4 w-4";

    switch (category) {
      case 1:
        return (
          <div className="flex items-center gap-2">
            <BookOpenIcon className={baseClass} />
            <span>Books</span>
          </div>
        );
      case 2:
        return (
          <div className="flex items-center gap-2">
            <DocumentCheckIcon className={baseClass} />
            <span>Report</span>
          </div>
        );
      case 3:
        return (
          <div className="flex items-center gap-2">
            <GlobeAmericasIcon className={baseClass} />
            <span>Press Release</span>
          </div>
        );
      case 4:
        return (
          <div className="flex items-center gap-2">
            <ClipboardDocumentIcon className={baseClass} />
            <span>Fact Sheet</span>
          </div>
        );
      case 5:
        return (
          <div className="flex items-center gap-2">
            <VideoCameraIcon className={baseClass} />
            <span>Videos</span>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <Card className="relative w-full max-w-[210px] overflow-hidden rounded-xl group">
      {/* Image */}
      <div className="aspect-[3/4] w-full">
        <img
          src={item?.imgUrl}
          alt={item?.title}
          className="h-full w-full object-cover"
        />
      </div>

      {/* Overlay */}
      <CardBody className="absolute inset-0 flex flex-col justify-between bg-black/60 p-4 text-white opacity-0 transition-opacity duration-300 group-hover:opacity-100">
        <div>
          <Typography
            variant="small"
            className="mb-2 text-xs uppercase tracking-wide text-white/80"
          >
            {IconHeader(item?.categoryCode)}
          </Typography>

          <Typography
            variant="h6"
            className="mb-2 line-clamp-2 md:line-clamp-3 text-sm font-semibold text-ifmpallet3"
          >
            {item?.title}
          </Typography>

          <Typography
            variant="small"
            className="line-clamp-3 md:line-clamp-6 text-xs text-white/90"
          >
            {item?.description}
          </Typography>
        </div>

        <a
          href={item?.fileUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-3"
        >
          <Button
            size="sm"
            fullWidth
            variant="outlined"
            color="white"
            className="flex items-center justify-center gap-2 border-white text-white"
          >
            <CloudArrowDownIcon className="h-4 w-4" />
            Download
          </Button>
        </a>
      </CardBody>
    </Card>
  );
}
